module.exports = "/** COLORS **/\n:host /deep/ * {\n  font-family: \"Open Sans\", sans-serif !important; }\n"